import gql from 'graphql-tag';
import { PromotionBasicFields } from './fragments/Promotion';

const key = `CreatePromotion`;

const mutation = gql`
${PromotionBasicFields}
mutation ${key}($input:CreatePromotionInput!) {
  createPromotion(input: $input) {
    ...PromotionBasicFields
  }
}
`;

export const CREATE_PROMOTION = { key, mutation };
